const ABOUT_IMG =
  "https://images.unsplash.com/photo-1522199755839-a2bacb67c546?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 sm:py-32 bg-[#FFF8F1] border-t border-[#4A1D96]/10 grain"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Image */}
        <div className="lg:col-span-6 reveal">
          <div className="relative">
            <div className="aspect-[4/5] overflow-hidden shadow-[0_30px_80px_-30px_rgba(74,29,150,0.35)]">
              <img
                src={ABOUT_IMG}
                alt="Business travel"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 hidden sm:block bg-[#F97316] text-white px-8 py-6 max-w-xs shadow-xl">
              <div className="font-serif text-4xl leading-none">2026</div>
              <div className="mt-2 text-xs uppercase tracking-[0.2em] font-semibold">
                The year Celesta took flight
              </div>
            </div>
            <div className="absolute -top-6 -left-6 hidden sm:block bg-[#4A1D96] text-white px-6 py-5 shadow-xl">
              <div className="font-serif text-2xl leading-none">Chennai</div>
              <div className="mt-1 text-[10px] uppercase tracking-[0.22em] text-[#FFB47A] font-semibold">
                Home office
              </div>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="lg:col-span-6 reveal">
          <span className="uppercase tracking-[0.28em] text-xs text-[#F97316] font-semibold">
            About Celesta
          </span>
          <h2
            data-testid="about-heading"
            className="mt-4 font-serif text-4xl sm:text-5xl leading-[1.05] text-[#1B0F3A]"
          >
            A travel desk built for
            <br />
            <span className="brand-gradient italic font-medium">
              businesses first,
            </span>
            <br />
            open to everyone.
          </h2>
          <div className="mt-8 space-y-6 text-[#3B2A5B] text-lg leading-relaxed max-w-xl">
            <p>
              Celesta began in 2026 at a small office on St. Thomas Street in
              Chennai, with a simple idea: business travel in India shouldn&apos;t
              feel like a helpdesk ticket. It should feel like a well-run
              chief-of-staff, quietly holding your calendar together.
            </p>
            <p>
              Today — from day one — we help founders, finance teams, family
              offices and families on holiday book flights, hotels, private
              cars, trains, curated packages and MICE events under one number
              and one named advisor.
            </p>
          </div>

          <div className="mt-10 grid grid-cols-2 gap-6 max-w-md">
            <div className="border-l-2 border-[#F97316] pl-4">
              <div className="font-serif text-2xl text-[#4A1D96]">2026</div>
              <div className="mt-1 text-xs uppercase tracking-[0.18em] text-[#3B2A5B]/70 font-semibold">
                Founded in Chennai
              </div>
            </div>
            <div className="border-l-2 border-[#F97316] pl-4">
              <div className="font-serif text-2xl text-[#4A1D96]">IATA</div>
              <div className="mt-1 text-xs uppercase tracking-[0.18em] text-[#3B2A5B]/70 font-semibold">
                Accredited agency
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
